import React from 'react';
import { View, Text, StyleSheet, Pressable, Linking, Image } from 'react-native';
import { Mail } from 'lucide-react';
import { webColors, webSpacing } from '../../constants/webStyles';
import { useIsMobile } from '../../hooks/useIsMobile';
import SupermedicLogo from '../../assets/images/supermedic-logo-web.png';

const WebFooter = () => {
  const isMobile = useIsMobile();

  const handleLink = (url) => {
    Linking.openURL(url);
  };

  const handleEmail = () => {
    Linking.openURL('mailto:support@supermedic.health');
  };

  const companyLinks = [
    { label: 'About Us', url: 'https://www.supermedic.health/about-us' },
    { label: 'Contact', url: 'https://www.supermedic.health/contact' },
  ];

  const supportLinks = [
    { label: 'Privacy Policy', url: 'https://docs.google.com/document/d/e/2PACX-1vTHVHow1mZ2VrJ44U-cKPxdGa99J4q1p7dmNpMhudGTqARoKAq824keHJmqFSPw76c7PvLPkNGAWqcf/pub?embedded=true' },
    { label: 'Terms & Conditions', url: 'https://docs.google.com/document/u/1/d/e/2PACX-1vR7TPQsU-svthrBmcWp0-TFEkVBdcJIBN7ICZoiAI3onDsMbhLprh9exxvMMn3npg/pub?embedded=true' },
  ];

  return (
    <View style={styles.footer}>
      <View style={[styles.footerContent, isMobile && styles.footerContentMobile]}>
        {/* Logo Section */}
        <View style={[styles.logoSection, isMobile && styles.logoSectionMobile]}>
          <Image
            source={SupermedicLogo}
            style={styles.logo}
            resizeMode="contain"
          />
        </View>

        {/* Links Container */}
        <View style={[styles.linksContainer, isMobile && styles.linksContainerMobile]}>
          {/* Company Section */}
          <View style={[styles.linkSection, isMobile && styles.linkSectionMobile]}>
            <Text style={styles.sectionTitle}>Company</Text>
            {companyLinks.map((link) => (
              <Pressable
                key={link.label}
                onPress={() => handleLink(link.url)}
                style={({ hovered }) => [
                  styles.linkItem,
                  hovered && styles.linkItemHover,
                ]}
              >
                <Text style={styles.linkText}>{link.label}</Text>
              </Pressable>
            ))}
          </View>

          {/* Support Section */}
          <View style={[styles.linkSection, isMobile && styles.linkSectionMobile]}>
            <Text style={styles.sectionTitle}>Support</Text>
            {supportLinks.map((link) => (
              <Pressable
                key={link.label}
                onPress={() => handleLink(link.url)}
                style={({ hovered }) => [
                  styles.linkItem,
                  hovered && styles.linkItemHover,
                ]}
              >
                <Text style={styles.linkText}>{link.label}</Text>
              </Pressable>
            ))}
          </View>

          {/* Get In Touch Section */}
          <View style={[styles.linkSection, isMobile && styles.linkSectionMobile]}>
            <Text style={styles.sectionTitle}>Get In Touch</Text>
            <Pressable
              onPress={handleEmail}
              style={({ hovered }) => [
                styles.emailLink,
                hovered && styles.linkItemHover,
              ]}
            >
              <Mail size={18} color={webColors.secondary} />
              <Text style={styles.emailText}>support@supermedic.health</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  footer: {
    backgroundColor: '#e8eef3',
    paddingVertical: 40,
    marginTop: 'auto',
  },
  footerContent: {
    maxWidth: webSpacing.containerMaxWidth,
    marginHorizontal: 'auto',
    paddingHorizontal: 40,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 72,
  },
  footerContentMobile: {
    flexDirection: 'column',
    alignItems: 'center',
    paddingHorizontal: 24,
    gap: 32,
  },
  logoSection: {
    flex: 1,
    maxWidth: 200,
  },
  logoSectionMobile: {
    alignItems: 'center',
    maxWidth: '100%',
  },
  logo: {
    width: 180,
    height: 45,

  },
  linksContainer: {
    flexDirection: 'row',
    gap: 80,
  },
  linksContainerMobile: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 28,
  },
  linkSection: {
    minWidth: 140,
  },
  linkSectionMobile: {
    alignItems: 'center',
    minWidth: 'auto',
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: webColors.textPrimary,
    marginBottom: 16,
  },
  linkItem: {
    paddingVertical: 4,
  },
  linkItemHover: {
    opacity: 0.7,
  },
  linkText: {
    fontSize: 14,
    color: webColors.textSecondary,
  },
  emailLink: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 4,
  },
  emailText: {
    fontSize: 14,
    color: webColors.textSecondary,
  },
});

export default WebFooter;
